/**
 * @description 材质编辑面板上的材质球展示窗口
 * @author
 * @creat
 */
import {
  DirectionalLight,
  PMREMGenerator,
  PerspectiveCamera,
  Scene,
  Vector3,
  WebGLRenderer,
  SRGBColorSpace,
  SphereGeometry,
  Mesh,
  MeshStandardMaterial,
  BoxGeometry,
} from "three";

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const MAP_NAMES = [
  "map",
  "aoMap",
  "emissiveMap",
  "glossinessMap",
  "metalnessMap",
  "normalMap",
  "roughnessMap",
  "specularMap",
];

export class MaterialSphere {
  constructor(el) {
    this.el = el;
    this.DEFAULT_CONTROL = "orbit";
    this.sphere = null;
    this.group = [];

    this.state = {
      aspect: false, //高度占比
      dispose: false,
      loadratio: 0.7, //模型加载占比
      addLights: true,
      textureEncoding: "sRGB",
      ambientIntensity: 1,
      ambientColor: 0xffffff,
      directIntensity: 2, // TODO(#116)
      directColor: 0xffffff,
      clientWidth: 240,
      clientHeight: 240,
      exposure: 1,
    };

    this.lights = [];

    this.scene = new Scene();

    const fov = 70;
    this.camera = new PerspectiveCamera(
      fov,
      this.state.clientWidth / this.state.clientHeight,
      1,
      1000
    );
    this.camera.lookAt(new Vector3(0, 0, 0));
    this.camera.position.set(15, 15, 0);
    this.scene.add(this.camera);

    //this.scene.add(new AxesHelper(1000));

    this.renderer = new WebGLRenderer({
      antialias: true,
      preserveDrawingBuffer: true,
      alpha: true,
    });
    this.renderer.physicallyCorrectLights = true;
    this.renderer.outputColorSpace = SRGBColorSpace;
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.state.clientWidth, this.state.clientHeight);
    this.renderer.setClearColor(0x787878, 1);
    //console.log("宽高不对啊：",this.state)

    this.renderer.localClippingEnabled = true;
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);

    this.controls.addEventListener("change", (object) => {
      this.render();
    });

    this.renderer.domElement.setAttribute(
      "style",
      "position:fixed;right:0px;z-index:999999;top: 400px;border: 1px solid;"
    );
    this.renderer.domElement.setAttribute("id", "materialsphere");

    //this.el.appendChild(this.renderer.domElement); // 当前版本不需要显示材质球

    this._createSphere(new MeshStandardMaterial({ color: 0xffffff }));
    this.addLights();
    this.render();
  }

  render() {
    this.renderer.render(this.scene, this.camera); // 当前版本不需要显示材质球
  }

  moveConfig = {
    speed: 0.04,
    minDistance: 0.01,
    slowdown: 1,
    slowdownSpeed: 0.01,
    speedx: 0.04,
    speedy: 0.04,
    speedz: 0.04,
  };

  resize() {
    if (!this.el || !this.el.parentElement) return;
    let { clientHeight, clientWidth } = this.el;

    if (this.state.aspect) clientHeight = clientWidth * this.state.aspect;

    this.camera.aspect = clientWidth / clientHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(clientWidth, clientHeight);
    this.render();
  }

  _createSphere(material) {
    let radius = 10;
    var sphereGeometry = new SphereGeometry(radius, 64, 64);
    var geometry = new BoxGeometry(radius, radius, radius);
    var sphereMaterial = material.clone();
    var sphereMaterial1 = material.clone();
    var sphere = new Mesh(sphereGeometry, sphereMaterial);
    var Geometry = new Mesh(geometry, sphereMaterial1);
    this.scene.add(Geometry);
    this.scene.add(sphere);
    this.group.push(sphere);
    this.group.push(Geometry);

    this.changeMesh();
    this.render();
    return sphere;
  }
  changeMesh(
    number = 0 //根据序号选择展示的物体
  ) {
    for (var i = 0; i < this.group.length; i++) {
      this.group[i].visible = false;
      if (i === number) {
        this.group[i].visible = true;
        if (this.sphere != null) this.group[i].material = this.sphere.material;
        this.sphere = this.group[i];
      }
    }
    this.render();
  }

  updateMaterial(material) {
    if (this.sphere && material) {
      this.sphere.material = material.clone();
    }
    this.render();
  }

  addLights() {
    const state = this.state;

    const light2 = new DirectionalLight(
      state.directColor,
      state.directIntensity
    );
    light2.position.set(30, 30, 30); // ~60º
    light2.name = "main_light";
    this.camera.add(light2);

    this.lights.push(light2);

    this.render();
  }

  getScreenshot() {
    return this.renderer.domElement.toDataURL("image/jpeg");
  }

  clear() {
    this.state.dispose = true;
    if (!this.content) return;

    this.scene.remove(this.content);

    // dispose geometry
    this.content.traverse((node) => {
      if (!node.isMesh) return;

      node.geometry.dispose();

      const materials = Array.isArray(node.material)
        ? node.material
        : [node.material];
      materials.forEach((material) => {
        MAP_NAMES.forEach((map) => {
          if (material[map]) material[map].dispose();
        });
      });
    });

    this.render();
  }

  _empty(scene) {
    while (scene.children.length > 0) scene.remove(scene.children[0]);
  }

  // 销毁整个场景以及场景中的一切
  dispose() {
    this.clear();
    this._empty(this.scene);
    this.scene.background = null;
    this.controls.dispose();
    this.scene.dispose();
    this.renderer.dispose();
    this.scene = null;
    this.renderer = null;
    this.camera = null;
    this.controls = null;
    this.content = null;
    this.sphere = null;
    this.group = null;
  }
}
